<template>
  <div class="floating-bar">
    <!-- 切换移动版 -->
    <div class="floating-item" @click="switchMobile">
      <i class="el-icon-mobile-phone"></i>
      <span>移动版</span>
    </div>

    <!-- 下载 -->
   <!-- <div class="floating-item" @click="downloadApp">
      <i class="el-icon-download"></i>
      <span>下载</span>
    </div> -->

    <!-- 客服 -->
<!--    <div class="floating-item" @click="openService">
      <i class="el-icon-service"></i>
      <span>客服</span>
    </div> -->

    <!-- 反馈 -->
  <!--  <div class="floating-item" @click="openFeedback">
      <i class="el-icon-edit-outline"></i>
      <span>反馈</span>
    </div> -->

    <!-- 回到顶部 -->
    <div class="floating-item" @click="scrollTop">
      <i class="el-icon-arrow-up"></i>
      <span>顶部</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "FloatingBar",
  methods: {
    switchMobile() {
       // 直接跳转到移动版网址
       window.location.href = "https://m.goucaiwang888.com";
    },
    // downloadApp() {
    //   this.$message.info("跳转到下载页面或显示二维码");
    // },
    // openService() {
    //   this.$message.info("这里对接客服系统");
    // },
    // openFeedback() {
    //   this.$message.info("跳转到反馈页面");
    // },
    scrollTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }
};
</script>

<style scoped>
.floating-bar {
  position: fixed;
  right: 20px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 3px;
  z-index: 9999;
}

.floating-item {
  width: 48px;
  height: 65px;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 12px;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
}

.floating-item:hover {
  background: #409EFF;
  transform: translateY(-2px);
}
</style>



// WEBPACK FOOTER //
// src/components/FloatingBar.vue